const userType = {
  SET_LOGIN_USER: "SET_LOGIN_USER",
  UPDATE_USER_DETAIL: "UPDATE_USER_DETAIL",
  SET_UPDATE_USER_DETAIL: "SET_UPDATE_USER_DETAIL",
  SET_UPDATE_USER_IMAGE: "SET_UPDATE_USER_IMAGE",
  START_LOGIN_OUT: "START_LOGIN_OUT",
  SET_LOGOUT_USER: "SET_LOGOUT_USER",
};

export default userType;
